<template>
  <div class="f-countdownTimer">


    <div :class="[{'f-timer-small':$store.getters.isMobileValue},'f-timer']">
      <ul id="f-countdownList">
        <li>
          <span class="f-timer-val">{{ days }}</span>
          <p class="f-timer-desc">days</p>
        </li>
        <li class="f-timer-sep ">:</li>
        <li>
          <span class="f-timer-val">{{ hours }}</span>
          <p class="f-timer-desc">hours</p>
        </li>
        <li class="f-timer-sep ">:</li>
        <li>
          <span class="f-timer-val">{{ minutes }}</span>
          <p class="f-timer-desc">minutes</p>
        </li>
        <li class="f-timer-sep ">:</li>
        <li>
          <span class="f-timer-val">{{ seconds }}</span>
          <p class="f-timer-desc">seconds</p>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'CountdownTimer',
    props: {
      date: {
        type: String
      }
    },
    data () {
      return {
        now: 0
      }
    },
    methods: {
      timerLoop () {
        this.now = Math.trunc(new Date().getTime() / 1000)
        setTimeout(this.timerLoop, 1000)
      }
    },
    mounted () {
      this.timerLoop()
    },
    computed: {

      seconds () {
        return ('0' + Math.trunc((this.modifiedDate - this.now) % 60)).slice(-2)
      },
      minutes () {
        return ('0' + Math.trunc(((this.modifiedDate - this.now) / 60) % 60)).slice(-2)
      },
      hours () {
        return ('0' + Math.trunc((((this.modifiedDate - this.now) / 60) / 60) % 24)).slice(-2)
      },
      days () {
        return ('0' + Math.trunc((((this.modifiedDate - this.now) / 60) / 60) / 24)).slice(-2)
      },
      modifiedDate: function () {
        return Math.trunc(Date.parse(this.date) / 1000)
      }
    }
  }
</script>

<style scoped>
  .f-countdownTimer {
    position: relative;
    background-color: rgba(135, 206, 250, 0.5);
    margin-top: 50px;
    margin-bottom: 50px;

  }

  .f-timer-small {
    font-size: 3em !important;
  }

  .f-timer {
    font-family: 'Ubuntu Mono', sans-serif;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 700;
    line-height: 1.2em;
    text-align: center;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 5em;
    max-width: 100%;
    overflow-x: hidden;
  }

  #f-countdownList {
    display: inline-block;
    list-style-type: none;
    padding: 0;
    overflow: auto;
    margin: auto;
  }

  #f-countdownList > li {
    float: left;
    text-align: center;
    position: relative;
    box-sizing: border-box;
    display: inline;
    white-space: nowrap;
    margin: 0 -1px;
  }

  .f-timer-val {
    margin: 0;
  }

  .f-timer-sep {

  }

  .f-timer-desc {
    font-weight: 200;
    font-size: .4em;
    line-height: 1em;
  }

</style>



// WEBPACK FOOTER //
// src/components/countdownComponents/CountdownTimer.vue